module.exports = __webpack_public_path__ + "img/741.afe82465.png";